import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { AuthenticationResponseModelData } from '../models/auth.model';

const API_BASE_URL = environment.stsUrl;
const OKTA_AUTH_URL = `${environment.apiUrl}api/TokenAuth/ExchangeExternal`;

@Injectable({
  providedIn: 'root'  
})
export class StsHttpService {
  private readonly customHttpClient: HttpClient;
  constructor(private readonly handler: HttpBackend) {
    this.customHttpClient = new HttpClient(handler);
  }

  //public methods
  public callSts(azureToken: string, partnerId: number): Observable<AuthenticationResponseModelData> {
    const body = {
      grantType: 'urn:ietf:params:oauth:grant-type:token-exchange',
      audience: 'Stealth',
      scope: 'StealthApis',
      subjectToken: azureToken,
      subjectTokenType: 'urn:ietf:params:oauth:token-type:id_token',
      actorTokenType: 'urn:ietf:params:oauth:token-type:id_token',
      partnerId: partnerId
    };

    return this.customHttpClient.post<AuthenticationResponseModelData>(
      OKTA_AUTH_URL,
      body
    );
  }

  // Okta → Gateway
  public callOAuth(oktaToken: string, partnerId: number): Observable<AuthenticationResponseModelData> {

    const body = {
      grantType: 'urn:ietf:params:oauth:grant-type:token-exchange',
      audience: 'Stealth',
      scope: 'StealthApis',
      subjectToken: oktaToken,
      subjectTokenType: 'urn:ietf:params:oauth:token-type:id_token',
      actorTokenType: 'urn:ietf:params:oauth:token-type:id_token',
      partnerId: partnerId
    };

    return this.customHttpClient.post<AuthenticationResponseModelData>(
      OKTA_AUTH_URL,
      body
    );
  }
}
